export default function withPageTitle(title: string) {
  document.title = title;
}
